export default __webpack_public_path__ + "static/icon-4-5-b804d4a598bbc57dc099caaf5720baf0.png";